import { combineReducers } from 'redux';
import download from './download';
import user from './user';
import runtime from './runtime';
import home from './home';
import search from './search';
import tag from './tag';
import mycourse from './mycourse';
import myorder from './myorder';
import login from './login';
import serial from './serial';
import course from './course'

export default combineReducers({
  download,
  user,
  home,
  search,
  tag,
  runtime,
  mycourse,
  myorder,
  login,
  serial,
  course,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js